import { AppActions } from "../../types";
import {
  InvestorDeskReport,
  BoardInfo,
  Director,
  ReportType,
  ReportYear,
  FinancialDocument,
  Regulation46Section,
} from "types/models/investorDeskMaster/InvestorDeskMasterApp";
import {
  GET_INVESTOR_DESK_SECTIONS,
  SET_INVESTOR_DESK_SECTION,
  RESET_INVESTOR_DESK_SECTION,
  GET_BOARD,
  GET_DIRECTORS,
  GET_REPORT_TYPES,
  GET_REPORT_YEARS,
  GET_FINANCIAL_DOCUMENTS,
  GET_REGULATION46_SECTIONS,
  GET_REGULATION46_DOCUMENTS,
} from "types/actions/investorDeskMaster.action";

const initialState: {
  sections: InvestorDeskReport[];
  currentSection: InvestorDeskReport | null;
  board: BoardInfo | null;
  directors: Director[];
  reportTypes: ReportType[];
  reportYears: ReportYear[];
  documents: FinancialDocument[];
  regulation46Sections: Regulation46Section[];
  regulation46Documents: FinancialDocument[];
} = {
  sections: [],
  currentSection: null,
  board: null,
  directors: [],
  reportTypes: [],
  reportYears: [],
  documents: [],
  regulation46Sections: [],
  regulation46Documents: [],
};

const InvestorDeskMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case GET_INVESTOR_DESK_SECTIONS:
      return { ...state, sections: action.payload };
    case SET_INVESTOR_DESK_SECTION:
      return { ...state, currentSection: action.payload };
    case RESET_INVESTOR_DESK_SECTION:
      return { ...state, currentSection: null };
    case GET_BOARD:
      return { ...state, board: action.payload };
    case GET_DIRECTORS:
      return { ...state, directors: action.payload };
    case GET_REPORT_TYPES:
      return { ...state, reportTypes: action.payload };
    case GET_REPORT_YEARS:
      return { ...state, reportYears: action.payload };
    case GET_FINANCIAL_DOCUMENTS:
      return { ...state, documents: action.payload };
    case GET_REGULATION46_SECTIONS:
      return { ...state, regulation46Sections: action.payload };
    case GET_REGULATION46_DOCUMENTS:
      return { ...state, regulation46Documents: action.payload };
    default:
      return state;
  }
};

export default InvestorDeskMaster;
